import { render } from "./CardCoinPreferenceList.vue?vue&type=template&id=3837c62b"
import script from "./CardCoinPreferenceList.vue?vue&type=script&lang=js"
export * from "./CardCoinPreferenceList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__